import * as React from "react";

const CordovaContext = React.createContext(false);

export default CordovaContext;


// WEBPACK FOOTER //
// ./src/cordovaContext.tsx